/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Reserva_Datos from "../../Formularios/Reservas/Formulario_Reserva_Datos";
import {Delete, AirlineSeatIndividualSuiteOutlined} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import Formulario_Reserva_Valores from "../../Formularios/Reservas/Formulario_Reserva_Valores";
import {useEffect, useState} from "react";
import Selector_Habitacion from "../../../Modulo_Motor_Reservas/Componentes/Selector_Habitacion";
import {FECHACHECKIN, FECHACHECKOUT, ORIGENESRESERVAS} from "../../../Modulo_Motor_Reservas/Constantes";
import {
    obtenerHabitacionesOcupadasEntreFechas
} from "../../../Modulo_Motor_Reservas/Controladores/obtenerHabitacionesOcupadasEntreFechas";
import {adaptador_habitacion_mas_reserva} from "../../Adaptadores/adaptador_habitacion_mas_reserva";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.svg"
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {obtenerFechaEstandarCheckOut} from "../../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckOut";
import {obtenerFechaEstandarCheckIn} from "../../../Modulo_Motor_Reservas/Funciones/obtenerFechaEstandarCheckIn";
import {obtenerHabitaciones} from "../../../Modulo_Motor_Reservas/Controladores/obtenerHabitaciones";
import {obtenerValorTotal} from "../../Utilidades/obtenerValorTotal";
import {obtenerNumNoches} from "../../../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";

const Dialogo_Reserva = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: {
            fechaCheckOut: new Date().getTime() + 1000 * 60 * 60 * 24,
            numNinos: 0,
            numAcompanantes: 0,
            ...datos
        }
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })
    const [habOcupadas, setHabOcupadas] = useState([])
    const [mostrarHabitaciones, setMostrarHabitaciones] = useState(false)
    const [cargando, setCargando] = useState(false)
    const [seleccionada, setSeleccionada] = useState({})
    const [habitaciones, setHabitaciones] = useState([])


    const subirDatos = async () => {

        verificarValores()

        let entidad = await obtenerEntidad()
        entidad = adaptador_habitacion_mas_reserva({reserva: entidad, habitacion: seleccionada})
        entidad.valor = obtenerValorTotal(entidad)

        iniciarCarga('Subiendo datos')
        if (!entidad.id) {
            entidad.fecha = new Date().getTime()
        }

        if (!entidad.estado) {
            entidad.estado = 'Reservada'
        }

        if (!entidad.origen) {
            entidad.origen = ORIGENESRESERVAS[0]
        }

        entidad[FECHACHECKIN] = obtenerFechaEstandarCheckIn(entidad[FECHACHECKIN])
        entidad[FECHACHECKOUT] = obtenerFechaEstandarCheckOut(entidad[FECHACHECKOUT])

        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            terminar({aviso: 'Datos subidos correctamente'})
        } else {
            terminar({aviso: 'Algo inesperado paso! datos no subidos', variante: 'error'})
        }


    }


    const borrar = async () => {
        await borrarDoc('reservas', datos.id)
        terminar({aviso: 'Registro borrado'})
    }

    const seleccionarHabitacion = (e) => {

        if (e.numero) {

            let fechaCheckIn = props.getValues(FECHACHECKIN)
            let fechaCheckOut = props.getValues(FECHACHECKOUT)
            let numNoches = obtenerNumNoches({
                fechaCheckIn: obtenerFechaEstandarCheckIn(fechaCheckIn),
                fechaCheckOut: obtenerFechaEstandarCheckOut(fechaCheckOut)
            })


            let adicionales = props.getValues('adicionales')
            let descuentos = props.getValues('descuentos')
            let numAcompanantes = props.getValues('numAcompanantes')
            let numNinos = props.getValues('numNinos')
            let valorSaldo = props.getValues('valorSaldo')

            let total = obtenerValorTotal({
                adicionales: adicionales,
                descuentos: descuentos,
                tarifa: e.tarifa,
                tarifaAcompanante: e.tarifaAcompanante,
                tarifaNinos: e.tarifaNinos,
                numNoches: numNoches,
                numAcompanantes: numAcompanantes,
                numNinos: numNinos
            })

            props.setValue('valorHabitacion', e.tarifa * numNoches)
            props.setValue('valorAcompanantes', obtenerValorNoche(numAcompanantes, e.tarifaAcompanante, numNoches))
            props.setValue('valorNinos', obtenerValorNoche(numNinos, e.tarifaNinos, numNoches))
            props.setValue('numero', e.numero)
            props.setValue('numNoches', numNoches)
            props.setValue('tarifa', e.tarifa)
            props.setValue('tarifaNinos', e.tarifaNinos)
            props.setValue('tarifaAcompanante', e.tarifaAcompanante)
            props.setValue('valor', total)
            props.setValue('valorSaldo', valorSaldo ? valorSaldo : total)
        }
        setSeleccionada(e)
    }

    const verificarValores = () => {

        let adicionales = props.getValues('adicionales')
        let descuentos = props.getValues('descuentos')
        let numAcompanantes = props.getValues('numAcompanantes')
        let numNinos = props.getValues('numNinos')
        let numNoches = props.getValues('numNoches')
        let tarifa = props.getValues('tarifa')
        let tarifaNinos = props.getValues('tarifaNinos')
        let tarifaAcompanante = props.getValues('tarifaAcompanante')

        let total = obtenerValorTotal({
            adicionales: adicionales,
            descuentos: descuentos,
            tarifa: tarifa,
            tarifaAcompanante: tarifaAcompanante,
            tarifaNinos: tarifaNinos,
            numNoches: numNoches,
            numAcompanantes: numAcompanantes,
            numNinos: numNinos
        })
        let valorSaldo = props.getValues('valorSaldo')

        props.setValue('valorHabitacion', tarifa * numNoches)
        props.setValue('valorAcompanantes', obtenerValorNoche(numAcompanantes, tarifaAcompanante, numNoches))
        props.setValue('valorNinos', obtenerValorNoche(numNinos, tarifaNinos, numNoches))
        props.setValue('valor', total)
        props.setValue('valorSaldo', valorSaldo ? valorSaldo : total)

    }

    const obtenerValorNoche = (numero = 0, tarifa, numNoches) => {

        return parseInt(numero) * tarifa * numNoches
    }

    const buscarDisponibles = async () => {


        let entidad = await obtenerEntidad()
        let fechaCheckIn = entidad[FECHACHECKIN]
        let fechaCheckOut = entidad[FECHACHECKOUT]

        let habs = await obtenerHabitacionesOcupadasEntreFechas({
            fechaCheckIn: fechaCheckIn,
            fechaCheckOut: fechaCheckOut
        })
        setHabOcupadas(habs)
        setMostrarHabitaciones(true)


    }

    useEffect(() => {

        if (mostrarHabitaciones) {
            setMostrarHabitaciones(false)
            setSeleccionada({})
        }


    }, [props.watch(FECHACHECKIN), props.watch(FECHACHECKOUT), props.watch('numNinos'), props.watch('numAcompanantes')])


    useEffect(() => {
        obtenerHabitaciones().then((dox) => {
            setHabitaciones(dox)
        })
    }, []);


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva_Datos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 4}}>
                <Button loading={cargando}
                        onClick={() => buscarDisponibles()}
                        variant={'outlined'} startIcon={<AirlineSeatIndividualSuiteOutlined/>}>Ver Suites disponibles</Button>

            </Grid>

            {mostrarHabitaciones &&
                <>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{my: 4}}>
                        <Selector_Habitacion habitaciones={habitaciones} habOcupadas={habOcupadas}
                                             seleccionada={seleccionada} setSeleccionada={seleccionarHabitacion}/>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                        <Formulario_Reserva_Valores props={props}/>
                    </Grid>

                </>

            }

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Reserva